// text deformer constants
export var TEXT_COLOR_DEFORMER = 'textColorDeformer';
export var TEXT_OPACITY_DEFORMER = 'textOpacityDeformer';
export var TEXT_PROGRESS_DEFORMER = 'textProgressDeformer';
export var TEXT_TRANSFORM_DEFORMER = 'textTransformDeformer';
export var TEXT_DEFORMERS = [
    TEXT_COLOR_DEFORMER,
    TEXT_OPACITY_DEFORMER,
    TEXT_PROGRESS_DEFORMER,
    TEXT_TRANSFORM_DEFORMER,
];
export var CENTER_SCALE_TRANSFORM_DEFORMER = 'centerScaleTransformDeformer';
export var CURVE_DEFORMER = 'curveDeformer';
export var TRANSFORM_DEFORMER = 'transformDeformer';
export var VERTEX_TRANSFORM_DEFORMER = 'vertexTransformDeformer';
export var BASE_DEFORMERS = [
    CENTER_SCALE_TRANSFORM_DEFORMER,
    CURVE_DEFORMER,
    TRANSFORM_DEFORMER,
    VERTEX_TRANSFORM_DEFORMER,
];
// text graphic deformer constants
export var TEXT_GRAPHIC_OPACITY_DEFORMER = 'textGraphicOpacityDeformer';
export var TEXT_GRAPHIC_DEFORMERS = [
    TEXT_GRAPHIC_OPACITY_DEFORMER,
];
// all deformers
export var ALL_DEFORMERS = TEXT_DEFORMERS
    .concat(BASE_DEFORMERS)
    .concat(TEXT_GRAPHIC_DEFORMERS);
